// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ebfj","index":"styles_index__2DoOC"};